module.exports = __webpack_public_path__ + "static/media/logonav2.70b61085.png";